import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-xs uppercase tracking-[0.28em] font-semibold ${
      light ? "text-[#C5A059]" : "text-[#B38C44]"
    }`}
  >
    {children}
  </p>
);
